import {mapMutations} from 'vuex'

export default {
  mounted() {
    const {title, hasFooter} = this.$options
    if (title != undefined) {
      document.title = this.is_empty(title)
        ? 'CUBIC-Cloud'
        : `CUBIC-Cloud - ${title}`
      if (hasFooter != undefined) {
        this.changeHasFooter(hasFooter)
      } else {
        this.changeHasFooter(true)
      }
    }
  },
  methods: {
    ...mapMutations({
      changeHasFooter: 'option/changeHasFooter',
    }),
  },
}
